import { render } from "./BukuTunai.vue?vue&type=template&id=0b5d5d32"
import script from "./BukuTunai.vue?vue&type=script&lang=js"
export * from "./BukuTunai.vue?vue&type=script&lang=js"

import "./BukuTunai.vue?vue&type=style&index=0&id=0b5d5d32&lang=css"
import "./BukuTunai.vue?vue&type=style&index=1&id=0b5d5d32&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__